var React = require('react');

function DropdownArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.948 5h-8a1 1 0 0 0-.812 1.583l3.825 5.333a1 1 0 0 0 1.6.033l4.174-5.333A1 1 0 0 0 11.948 5z"}));
}

DropdownArrow.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"currentColor"};

module.exports = DropdownArrow;

DropdownArrow.default = DropdownArrow;
